import { useDraggable } from "@dnd-kit/core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import classNames from "classnames";
import { DragHandleIcon } from "../../icons";
import { DragHandleProps, PlannerAutomation } from "./journeyPlanner.types";
import AutomationStatusBadge from "./AutomationStatusBadge";

function SidebarAutomationCardContent({
  automation,
  dragHandleAttributes,
  dragHandleListeners,
  dragHandleRef,
  showDragHandle = true,
}: DragHandleProps & {
  automation: PlannerAutomation;
  showDragHandle?: boolean;
}) {
  return (
    <div className="bg-white border rounded-2 py-3 pe-3 ps-2">
      <div className="d-flex justify-content-between align-items-start gap-3">
        {showDragHandle && (
          <div
            className="drag-handle d-inline-flex align-items-center justify-content-center flex-shrink-0 fs-6"
            ref={dragHandleRef}
            title="Move automation"
            {...dragHandleAttributes}
            {...dragHandleListeners}
          >
            <FontAwesomeIcon icon={DragHandleIcon} />
          </div>
        )}
        <div className="flex-grow-1">
          <strong>{automation.Name}</strong>
          {automation.CommunicationName && (
            <div className="small text-muted">
              {automation.CommunicationName}
            </div>
          )}
        </div>
        <AutomationStatusBadge status={automation.Status} />
      </div>
    </div>
  );
}

function SidebarAutomationCard({
  automation,
  className,
  draggable = true,
}: {
  automation: PlannerAutomation;
  className?: string;
  draggable?: boolean;
}) {
  // The overlay is what travels; the card stays in the dock, faded, so the dock can't clip it.
  const { attributes, isDragging, listeners, setActivatorNodeRef, setNodeRef } =
    useDraggable({
      disabled: !draggable,
      id: `sidebar-automation-${automation.Id}`,
      data: {
        type: "sidebar-automation",
        automation,
        automationId: automation.Id,
        label: automation.Name,
        name: automation.Name,
      },
    });

  return (
    <div
      className={classNames("mb-3", className, { "opacity-50": draggable && isDragging })}
      ref={draggable ? setNodeRef : undefined}
    >
      <SidebarAutomationCardContent
        automation={automation}
        dragHandleAttributes={draggable ? attributes : undefined}
        dragHandleListeners={draggable ? listeners : undefined}
        dragHandleRef={draggable ? setActivatorNodeRef : undefined}
      />
    </div>
  );
}

export { SidebarAutomationCardContent };
export default SidebarAutomationCard;
